import { z } from 'zod';

const zodExportAttachmentSchema = z.object({
  contentType: z.string(),
  filename: z.string(),
  sizeBytes: z.number().int(),
  source: z.enum([
    'invoice',
    'delivery_notes',
    'invoice_check_protocol',
    'misc',
    'performance_record',
    'raw_invoice_pdf',
    'processed_pdf',
    'parsing_input',
    'incoming_email',
    'outgoing_email',
    'user_file',
  ]),
});

export const zodExportAttemptSchema = z.object({
  attachments: z.array(zodExportAttachmentSchema).nullish(),
  channel: z.enum(['email', 'sftp', 'partner_api']),
  createdOn: z.iso.datetime({ offset: true }).nullish(),
  errorMessage: z.string().nullish(),
  exportRuleId: z.uuid().nullish(),
  failurePhase: z.enum(['prepare', 'send', 'verify']).nullish(),
  id: z.uuid(),
  lastErrorAt: z.iso.datetime({ offset: true }).nullish(),
  outgoingFileId: z.uuid().nullish(),
  ruleName: z.string().nullish(),
  sendTimestamp: z.iso.datetime({ offset: true }).nullish(),
  status: z.enum([
    'queued',
    'preparing',
    'sending',
    'awaiting_verify',
    'succeeded',
    'failed',
  ]),
  trigger: z.enum(['after_complete', 'on_receipt', 'on_rejection']),
  updatedOn: z.iso.datetime({ offset: true }).nullish(),
});

export const zodExportAttemptsResponseSchema = z.object({
  data: z.array(zodExportAttemptSchema),
  exportSummary: z
    .enum(['none', 'pending', 'succeeded', 'partial_failure', 'failed'])
    .nullish(),
});
